/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Multiplevalidationerrors2Inputs */



/**

* @param {Multiplevalidationerrors2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const multiplevalidationerrors2 = /** @type {((inputs?: Multiplevalidationerrors2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Multiplevalidationerrors2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Es sind mehrere Fehler aufgetreten.")
});
export { multiplevalidationerrors2 as "multipleValidationErrors" }